import { z } from "zod/v4";
import { barComparisonComponentSchema } from "@/lib/ai/visualization/views/bar-comparison/schema";
import { barRankingComponentSchema } from "@/lib/ai/visualization/views/bar-ranking/schema";
import { scatterPlotComponentSchema } from "@/lib/ai/visualization/views/scatter-plot/schema";
import { tableComponentSchema } from "@/lib/ai/visualization/views/table/schema";
import { timeSeriesAreaComponentSchema } from "@/lib/ai/visualization/views/time-series-area/schema";
import { timeSeriesComposedComponentSchema } from "@/lib/ai/visualization/views/time-series-composed/schema";
import { timeSeriesGroupedLineComponentSchema } from "@/lib/ai/visualization/views/time-series-grouped-line/schema";
import { timeSeriesLineComponentSchema } from "@/lib/ai/visualization/views/time-series-line/schema";

const vizCardComponentSchema = z
  .object({
    title: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    footnote: z.string().optional().nullable(),
  })
  .strict();

/**
 * json-render catalog に登録する component schema 群。
 *
 * @remarks
 * runtime catalog は view 定義とは独立に component props 契約を読むため、
 * schema 集約はこのファイルを正本とする。
 * `catalog.prompt()` が `unknown` へ落ちる wrapper を避けるため、
 * ここから辿る runtime component schema では `z.preprocess` /
 * `z.transform` / `.default()` / `z.record()` を使わない。
 */
export const vizComponentSchemas = {
  VizCard: vizCardComponentSchema,
  TimeSeriesLine: timeSeriesLineComponentSchema,
  TimeSeriesGroupedLine: timeSeriesGroupedLineComponentSchema,
  TimeSeriesArea: timeSeriesAreaComponentSchema,
  TimeSeriesComposed: timeSeriesComposedComponentSchema,
  ScatterPlot: scatterPlotComponentSchema,
  VizTable: tableComponentSchema,
  BarRanking: barRankingComponentSchema,
  BarComparison: barComparisonComponentSchema,
} as const;

export type VizComponentName = keyof typeof vizComponentSchemas;

export type VizComponentPropsByName = {
  [K in VizComponentName]: z.infer<(typeof vizComponentSchemas)[K]>;
};
